import { render } from "./SquarePlusIcon.vue?vue&type=template&id=c8d85ee6"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__